import { render, staticRenderFns } from "./CashAdvanceLimit.vue?vue&type=template&id=06998907"
import script from "./CashAdvanceLimit.vue?vue&type=script&lang=js"
export * from "./CashAdvanceLimit.vue?vue&type=script&lang=js"
import style0 from "./CashAdvanceLimit.vue?vue&type=style&index=0&id=06998907&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports